import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint = 768) => {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    // Function to check the window width
    const checkIsMobile = () => {
      setIsMobileView(window.innerWidth < breakpoint);
    };

    // Check on initial render
    checkIsMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIsMobile);

    // Cleanup the event listener when the component unmounts
    return () => window.removeEventListener('resize', checkIsMobile);
  }, [breakpoint]); // Re-run effect if the breakpoint changes

  return isMobileView;
};

export default useIsMobile;